import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=c644183c&scoped=true&"
import script from "./InspectionList.vue?vue&type=script&lang=js&"
export * from "./InspectionList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InspectionList.vue?vue&type=style&index=1&id=c644183c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c644183c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VContainer,VDataTable,VDialog,VIcon,VTextField})
